import { OpenInNew as OpenInNewIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { Box, Chip, Link as MuiLink, Tooltip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router';

import type { ParsedIManageDocument } from '@/apps/engagement-letter-database/hooks/useParseRecords';
import { buildIManageUrl } from '@/shared/helpers/imanageUrlUtils';


export const createWaiverDocColumns = (): GridColDef<ParsedIManageDocument>[] => [
  { field: 'documentName', headerName: 'Document Name', flex: 1 },
  { field: 'iManageDocNumber', headerName: 'iManage Doc Number', flex: 1 },
  {
    field: 'iManageLink',
    headerName: 'iManage Link',
    flex: 1,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title="Link resolved successfully">
          <CheckCircleIcon fontSize="small" color="success" />
        </Tooltip>
        <MuiLink
          component={RouterLink}
          to={buildIManageUrl(params.row.docId)}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'primary.main',
          }}
        >
          Open in iManage
          <OpenInNewIcon fontSize="small" />
        </MuiLink>
        <Tooltip title={`Document: ${params.row.docId}`}>
          <Chip
            label={params.row.docId}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.7rem', height: 20 }}
          />
        </Tooltip>
      </Box>
    ),
  },
];
